import { Button, Icon, Label } from "semantic-ui-react";

import { useTranslation } from "react-i18next";

import Flex from "../../../../../components/Flex/Flex";
import useHasRight from "../../../../authorization/hooks/useHasRight";
import SecondaryButton from "../../../../ui/components/Buttons/SecondaryButton";

import CalendarDoneOrNotifyButton from "./CalendarDoneOrNotifyButton";

export default function CalendarHeaderToolbarTools({
	desktop,
	onClickFilter,
	filterForm,
	isEditing,
	onClickEdit,
	isBooking,
	onClickBook,
	onStopBooking,
	modifiedSessions,
	onOpenNotifyModal,
	onOpenAvailabilityModal,
	resourceType,
}) {
	const { t } = useTranslation();
	const hasRight = useHasRight();

	const canEditSessions = hasRight("calendar.editAllSessions") || hasRight("calendar.editOwnSessions");

	return (
		<Flex justifyContent="flex-start" gap={5} style={{ flex: 0, whiteSpace: "nowrap" }}>
			<div style={{ position: "relative" }}>
				<Button basic size="tiny" icon onClick={onClickFilter} style={{ paddingLeft: 16, paddingRight: 16 }}>
					<Icon name="filter" />

					{desktop && <span style={{ marginLeft: 3 }}>{t("filters", "Filters")}</span>}
				</Button>

				{filterForm.activeFilters > 0 && (
					<Label color="blue" floating circular size="tiny">
						{filterForm.activeFilters}
					</Label>
				)}
			</div>

			{canEditSessions && !isEditing && (
				<SecondaryButton basic size="tiny" icon onClick={onClickEdit}>
					<Icon name="pencil" />

					{desktop && <span style={{ marginLeft: 3 }}>{t("editSessions", "Edit sessions")}</span>}
				</SecondaryButton>
			)}

			{!isBooking && !isEditing && canEditSessions && (
				<SecondaryButton
					disabled={isEditing || resourceType !== "studios"}
					size="tiny"
					onClick={onClickBook}
					basic
					icon
				>
					<Icon name="calendar plus outline" />

					{desktop && <span style={{ marginLeft: 3 }}>{t("book", "Book")}</span>}
				</SecondaryButton>
			)}

			{(isBooking || isEditing) && (
				<CalendarDoneOrNotifyButton
					onOpenNotifyModal={onOpenNotifyModal}
					onStopBooking={onStopBooking}
					modifiedSessions={modifiedSessions}
				/>
			)}

			<SecondaryButton basic size="tiny" icon onClick={onOpenAvailabilityModal}>
				<Icon name="calendar lines pen" />

				{desktop && <span style={{ marginLeft: 3 }}>{t("availability", "Availability")}</span>}
			</SecondaryButton>
		</Flex>
	);
}
